
	import { Vue,Component } from 'vue-property-decorator'
	import partner from '../../components/partner.vue'
	import { State,Action,namespace } from 'vuex-class'
	const dashboard = namespace('dashboard')
    @Component({
        components: {
            partner
        }
    })
    export default class Shelves extends Vue{
		radio = '1'
		reason = ''
		partner:string = ''
        detail:any = null
		// @site.State('shelves') shelves:any
		@dashboard.Action('getNoticeDetail') getNoticeDetail:any
		@dashboard.Action('auditDetail') auditDetail:any
		
		async mounted(){
			const res = await this.getNoticeDetail(this.$route.query.id);
			this.detail = res;
			console.log(res);
		}
		async sendFun(){
			if(this.radio == '9'){
				if(this.reason){
					const res = await this.auditDetail({
						id: this.detail._id,
						data: {
							status: 9,
							reason: this.reason
						}
					});
					if(res){
						this.$message({
							message: '操作完成',
							type: 'success',
							duration: 2000
						});
						setTimeout(() => {
							this.$router.back()
						},2000)
					}
				}else{
					this.$message({
						message: '请填写拒绝理由',
						type: 'warning'
					});
				}
			}else{
				const res = await this.auditDetail({
					id: this.detail._id,
					data: {
						status: 1,
						partner: this.partner
					}
				});
				if(res){
					this.$message({
						message: '操作完成',
						type: 'success',
						duration: 2000
					});
					setTimeout(() => {
						this.$router.back()
					},2000)
				}
			}
		}
    }
